import { Directive, HostListener, ElementRef, Renderer2 } from "@angular/core";

@Directive({
    selector: "[kno2SocialSecurityNumberFormatter]",
    exportAs: "kno2SocialSecurityNumberFormatter",
    standalone: false
})
export class SocialSecurityNumberFormatterDirective {
    @HostListener("keypress", ["$event"])
    public onKeydown(event: KeyboardEvent): void {
        const pattern = /[0-9]/,
            validCodes = [
                8, // backspace
                13 // enter
            ];

        const code = event.keyCode;
        if (!code || validCodes.includes(code)) return;

        const char = String.fromCharCode(code);
        const inputEl = this.host.nativeElement as HTMLInputElement;

        if (!pattern.test(char) || inputEl.value.length >= 11) event.preventDefault();
    }

    @HostListener("ngModelChange")
    public onChange(): void {
        const inputEl = this.host.nativeElement as HTMLInputElement;
        const newInput = inputEl.value;
        this.renderer.setProperty(inputEl, "value", this.formatSocialSecurityNumber(newInput));
    }

    constructor(
        private renderer: Renderer2,
        private host: ElementRef
    ) {}

    private formatSocialSecurityNumber(validSocialSecurityNumber: string): string {
        const normalizedNumber = validSocialSecurityNumber.split("-").join("");
        let numberWithDashes = "";
        numberWithDashes += `${normalizedNumber.slice(0, 3) || ""}${normalizedNumber.length > 3 ? "-" : ""}`;
        numberWithDashes += `${normalizedNumber.slice(3, 5) || ""}${normalizedNumber.length > 5 ? "-" : ""}`;
        numberWithDashes += `${normalizedNumber.slice(5, normalizedNumber.length) || ""}`;
        return numberWithDashes;
    }
}
